module.exports = "././img/roboto-v16-latin-regular.eot";


//////////////////
// WEBPACK FOOTER
// ../fonts/roboto-v16-latin-regular.eot
// module id = 268
// module chunks = 0